module.exports = __webpack_public_path__ + "img/BeiFangHuaChuang.de86eb6a.png";